<template>
  <!-- Compte Free sur une page Pro : on affiche directement le modal des prix
       (pas de page-barrière). Fermeture -> on revient en arrière. -->
  <UpgradeModal v-if="isFree" :show="true" current-plan-slug="connect" @close="goBack" />
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import { apiBaseUrl } from '../config';
import UpgradeModal from './UpgradeModal.vue';

export default {
  name: 'ProGate',
  components: { UpgradeModal },
  props: {
    // conservé pour compat. avec les pages (<ProGate feature="…"/>)
    feature: { type: String, default: 'cette fonctionnalité' }
  },
  setup() {
    const router = useRouter();
    const isFree = ref(false);

    const goBack = () => {
      if (window.history.length > 1) router.back();
      else router.push('/dashboard');
    };

    onMounted(async () => {
      try {
        const raw = JSON.parse(localStorage.getItem('user') || '{}');
        const token = (raw && raw.data && raw.data.token) || raw.token;
        if (!token) return; // fail-open : on ne bloque pas sans info
        const { data } = await axios.get(`${apiBaseUrl}/strong/billing/my-plan`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        // Free = plan_slug 'connect'. On n'ouvre le modal QUE si on a confirmé Free.
        if (data && data.success && data.plan_slug) {
          isFree.value = (data.plan_slug === 'connect');
        }
      } catch (e) {
        // fail-open : en cas d'erreur réseau on ne bloque pas (évite de gêner un compte Pro)
        console.warn('ProGate: vérification du plan impossible', e?.message);
      }
    });

    return { isFree, goBack };
  }
};
</script>
